<template>
    <v-card>
        <v-alert
            v-if="mode === 'SHOW_ERROR'"
            color="red"
            outlined
            type="error"
        >
            <v-row>
                <v-col class="d-flex justify-center">{{this.message}}</v-col>
            </v-row>
        </v-alert>
        <v-alert
            v-if="mode === 'REDIRECT'"
            outlined
            type="info"
            color="blue"
        >
            <v-row>
                <v-col class="d-flex justify-center">{{this.message}}</v-col>
            </v-row>
            <v-row align="center"
                   justify="center">
                <v-col class="d-flex justify-center">
                    <v-btn
                        depressed
                        color="primary"
                        @click="onRedirect"
                    >
                        Перейти
                    </v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <v-alert
            v-if="'SHOW_FORM' === mode"
            colored-border
            elevation="2"
        >
            <v-row>
                <v-col class="d-flex justify-center">{{this.message}}</v-col>
            </v-row>
            <v-row align="center"
                   justify="center">
                <v-col class="d-flex justify-center">
                    <v-btn
                        depressed
                        color="success"
                        class="mr-2"
                        @click="onAccept"
                    >
                        Принять
                    </v-btn>
                    <v-btn
                        depressed
                        color="error"
                        @click="onReject"
                    >
                        Отклонить
                    </v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <notification></notification>
    </v-card>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
}
</style>
<script>
import * as api from '@/api/workspace';
import {mapActions} from 'vuex';
import {setRedirectOnLogin} from "../../../plugins/utils";
import Notification from "../Notification.vue";
export default {
    components: {Notification},
    name: 'WorkSpaceInvite',
    props:{
        token: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isFetch: false,
            state: null,
            message: null,
        }
    },
    created() {
        this.load();
    },
    methods: {
        ...mapActions('notifications', ['SHOW_SUCCESS', 'SHOW_ERROR', 'SHOW_RESPONSE_ERROR']),
        async load(){
            this.isFetch = true;
            try {
                let {data} = await api.inviteShow(this.token);
                this.state = data.state;
                this.message = data.message;
            }catch (e) {
                console.log(e);
                this.SHOW_RESPONSE_ERROR({errorResponse: e, defaultError: 'Произошла ошибка загрузки приглашения ('});
            }finally {
                this.isFetch = false;
            }
        },
        onRedirect(){
            if('TO_AUTH' === this.state){
                setRedirectOnLogin({name: 'WorkSpaceInvitePage', params: {token: this.token}});
                this.$router.push({name: 'Login'})
            }
            if('TO_REGISTRATION' === this.state){
                setRedirectOnLogin({name: 'WorkSpaceInvitePage', params: {token: this.token}});
                this.$router.push({name: 'Login', params: {initLoginTabs: "tab-newUser"}})
            }
        },
        handleError(err, defaultError){
            if(err.response.data && err.response.data.state){
                this.state = err.response.data.state;
                this.message = err.response.data.error;
            }else {
                this.SHOW_RESPONSE_ERROR({errorResponse: err, defaultError: defaultError});
            }
        },
        async onAccept(){
            this.isFetch = true;
            try {
                let {data} = await api.inviteAccept(this.token);
                this.SHOW_SUCCESS(data.message);
                this.$emit('accept', {work_space_id: data.work_space_id});
            }catch (e) {
                console.log(e);
                this.handleError(e, 'Произошла ошибка принятия приглашения (');
            }finally {
                this.isFetch = false;
            }
        },
        async onReject(){
            this.isFetch = true;
            try {
                let {data} = await api.inviteReject(this.token);
                this.SHOW_SUCCESS(data.message);
                this.$emit('reject', this.token);
            }catch (e) {
                console.log(e);
                this.handleError(e, 'Произошла ошибка отклонения приглашения (');
            }finally {
                this.isFetch = false;
            }
        }
    },
    computed:{
        mode(){
            if('INVITE_NOT_FOUND' === this.state || 'INVITE_OVERDUE' === this.state){
                return 'SHOW_ERROR';
            }
            if('TO_AUTH' === this.state || 'TO_REGISTRATION' === this.state){
                return 'REDIRECT';
            }
            if('ok' === this.state){
                return 'SHOW_FORM'
            }
            return '';
        }
    }
}
</script>
